"use client";

import { trans } from "@/service/i18n/i18n";
import { Button } from "@/components/ui/button";
import { SuperLink as Link } from "@/components/common/super-link";
import { createPath } from "@/service/routing/routing";
import { NurseOrMidwifePrescriptionUnlock } from "@/components/common/nurse-or-midwife-prescription-unlock";
import { UserContext } from "@/contexts/user-context";
import { useContext } from "react";

export const EnablePrescription = () => {
  const user = useContext(UserContext);

  return (
    <>
      <h2
        className={`text-card-foreground mb-6 text-center text-2xl font-semibold`}
      >
        {trans("hello")} {user.shortName},
      </h2>
      <p className={`text-foreground mb-6 text-center text-base font-normal`}>
        Ta treść jest dostępna tylko dla osób mogących wypisywać recepty. Taki
        obowiązek nakłada na nas polskie prawo. Jeżeli jesteś
        pięlęgniarka/położna i masz taką możliwość, to dodaj zdjęcie dokumentu
        potwierdzającego uprawnienia i będziesz mogła/mógł korzystać ze
        wszystkich takich treści w Remedium
      </p>

      <Button asChild={true} variant="outline" className="w-full">
        <Link href={createPath("homepage")}>{trans("back_to_main_page")}</Link>
      </Button>

      <NurseOrMidwifePrescriptionUnlock />
    </>
  );
};
